<div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
      <!-- Forgot Password v1 -->
      <div class="card mb-0">
        <div class="card-body">
          <a href="javascript:void(0);" class="brand-logo">
            <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" height="28" />
            <h2 class="brand-text text-primary ml-1">Vuexy</h2>
          </a>
  
          <h4 class="card-title mb-1">Cuenta activada</h4>
          <p class="card-text mb-2"></p>
  

          <button  routerLink="" class="btn btn-primary btn-block" tabindex="2" rippleEffect>Volver a login</button>
        </div>
      </div>
      <!-- /Forgot Password v1 -->
    </div>
  </div>

  
  